import React from "react";
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
// import Info from './info';
import Info from './departures_info';
import Chip from '@mui/material/Chip';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const SellerDepartures = () => {

    const [lastUpdate, setLasUpdate] = React.useState('Sin datos');

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Despachos mis clientes
                    </Typography>
                </div>
                <hr />
                <Chip color="primary" style={{marginRight: '20px'}} icon={<UploadFileIcon />} label={`Última actualización: ${lastUpdate}`} variant="outlined" />
                <div style={{overflowY: 'auto'}}>
                    {
                        <Info setLastUpdate={(date) => setLasUpdate(date)} />
                    }               
                </div> 
            </Grid>
        </Grid>
    );
}

export default SellerDepartures;